module.exports = __webpack_public_path__ + "static/media/silver-bar-overview.1c9efa73.png";